import { useTranslation } from 'react-i18next';
import { StatusBadge } from '../StatusBadge';

export function PickListPendingSplitBadge() {
  const { t } = useTranslation('picklist');
  return <StatusBadge tone="warn">{t('auto_split_pending.label')}</StatusBadge>;
}
